<app-modal class="equipment-modal" [isLoading]="isLoading">
    <ng-container modal-header>
        <h5 class="modal-title">{{ 'admin.tools.details.detailsPage.modals.partNumberEditModal.title' | translate }}</h5>
    </ng-container>
    <ng-container modal-body>
        <app-part-number-form
            *ngIf="selectedPartNumbers"
            [showValidations]="showPartNumberFormValidations"
            [selectedPartNumbers]="selectedPartNumbers"
            [availablePartNumbers]="availablePartNumbers">
        </app-part-number-form>
    </ng-container>
    <div class="footer" modal-footer>
        <app-button type="simple"
                    [disabled]="isLoading"
                    (click)="close()">{{ 'generic.buttons.close' | translate }}
        </app-button>
        <app-button type="primary"
                    [disabled]="isLoading"
                    (click)="firePartNumbersUpdate()">
            {{ 'generic.buttons.update'| translate }}
        </app-button>
    </div>
</app-modal>
